module.exports = __webpack_public_path__ + "img/20_105.94fdacfe.png";